export var PRICE_ALERT_TYPES = {
    HIGHER_THAN: "1",
    LOWER_THAN: "2"
};

export var SCALED_ORDER_DISTRIBUTION_TYPES = {
    FLAT: "flat"
};

export var SCALED_ORDER_ACTION_TYPES = {
    BUY: "buy",
    SELL: "sell"
};